import React from 'react';
import PropTypes from "prop-types";
import { i18n } from 'core/i18n';
import { EmptyState } from 'commonsComponents/emptyState'
import './landingError.scss';

export const LandingError = ({ onRefetch }) => {
    const { FormattedText, formatText } = i18n;

    return (
        <div className="landing-offers-view-error">
            <EmptyState
                iconType="noitems-banking"
                primaryText={formatText('contractsView-contractView_landingOfferErrorTitle')}
                secondaryText={formatText('contractsView-contractView_landingOfferErrorSubtitle')}
                button={(
                    <button
                        className="buttons-base buttons-base--regular buttons-base--secondary"
                        onClick={onRefetch}
                    >
                        <FormattedText value="contractsView-contractView_landingOfferErrorCTA" />
                    </button>
                )}
            />
        </div>
    )
}

LandingError.propTypes = {
    onRefetch: PropTypes.func.isRequired

};
